import makeApiCall from "./master/axiosIndex";

export interface ScheduleMonthPayload {
  scheduleMonth: string; // 'YYYY-MM-01'
  scheduledQty: string;  // decimal as string
}

// Monthly production schedule per task: the user phases the task's work
// quantity across calendar months. Save is a full REPLACE-SET of the task's
// months (empty = clear); the Excel upload replaces the schedule of every task
// present in the file.
export const taskScheduleApis = {
  save: (taskId: number, months: ScheduleMonthPayload[]): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/save`,
      method: "post",
      data: { taskId, months },
    });
  },
  getByTask: (taskId: number | string): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/task/${taskId}`,
      method: "get",
    });
  },
  getProjectSummary: (
    projectId: number | string,
    filters: { phaseId?: number | string; activityId?: number | string } = {}
  ): Promise<any> => {
    const params: Record<string, any> = {};
    (["phaseId", "activityId"] as const).forEach((key) => {
      const value = filters[key];
      if (value !== undefined && value !== null && `${value}`.trim() !== "") {
        params[key] = value;
      }
    });
    return makeApiCall({
      url: `/task-schedule/project/${projectId}/summary`,
      method: "get",
      params,
    });
  },
  uploadExcel: (formData: FormData): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/upload/excel`,
      method: "post",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export interface ActualMonthPayload {
  actualMonth: string; // 'YYYY-MM-01'
  actualQty: string;   // decimal as string
  remarks?: string;
}

export interface ClientPlanMonthPayload {
  planMonth: string;      // 'YYYY-MM-01'
  plannedAmount: string;  // ₹ as string
  remarks?: string;
}

// Monthly ACTUAL execution per task (the executed twin of the schedule) +
// the project-level client-plan program. Form save is a full replace-set;
// the actuals Excel upload replaces only the file's months per task.
export const taskActualApis = {
  save: (taskId: number, months: ActualMonthPayload[]): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/actual/save`,
      method: "post",
      data: { taskId, months },
    });
  },
  getByTask: (taskId: number | string): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/actual/task/${taskId}`,
      method: "get",
    });
  },
  uploadExcel: (formData: FormData): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/actual/upload/excel`,
      method: "post",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  saveClientPlan: (projectId: number, months: ClientPlanMonthPayload[]): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/client-plan/save`,
      method: "post",
      data: { projectId, months },
    });
  },
  getClientPlan: (projectId: number | string): Promise<any> => {
    return makeApiCall({
      url: `/task-schedule/client-plan/${projectId}`,
      method: "get",
    });
  },
};
